<template>
	<v-form lazy-validation @submit.prevent="submit">
		<v-layout wrap justify-space-around fill-height align-center>
			<v-flex xs12 sm4>
				<v-text-field label="Título" v-model="v.title.$model" outline :error-messages="titleErrors"></v-text-field>
			</v-flex>
			<v-flex xs12 sm6>
				<v-textarea
					id="descriptionField"
					outline
					label="Descripción"
					v-model="v.description.$model"
					:error-messages="descriptionErrors"
					rows="10"
				></v-textarea>
			</v-flex>
		</v-layout>
	</v-form>
</template>

<script>
	import { required } from "vuelidate/lib/validators";
	export default {
		props: ["value", "v"],

		data: () => ({
			noticeForm: {}
		}),
		computed: {
			titleErrors() {
				const errors = [];
				if (!this.v.title.$dirty) return errors;
				!this.v.title.required && errors.push("Título requerido");
				return errors;
			},
			descriptionErrors() {
				const errors = [];
				if (!this.v.description.$dirty) return errors;
				!this.v.description.required && errors.push("Descripción requerida");
				return errors;
			}
		}
	};
</script>

<style>
	label[for*="descriptionField"],
	label[htmlfor*="descriptionField"] {
		top: 0;
		line-height: 13px !important;
	}
</style>
